module.exports = __webpack_public_path__ + "static/media/header_search_icon.951f16ee.svg";